import { PuzzleTypeIdEnum } from '../../puzzle-framework-module/puzzle-type-id.enum';
import { generate } from 'bridges-generator';

/**
 * Generates a Hashi (Bridges) puzzle using bridges-generator and emits
 * the JSON schema expected by the board:
 * { puzzle: number[][], solution: string[][] }
 */
export function generateHashiPuzzle(
  rows: number = 10,
  columns: number = 10,
  numberOfIslands: number = 5,
  doubleBridges: number = 0.2
) {
  try {
    const produced = generate(rows, columns, numberOfIslands, doubleBridges);
    return {
      type: PuzzleTypeIdEnum.HASHI,
      id: `hashi-${Date.now()}`,
      puzzle: produced.puzzle,
      solution: produced.solution,
    };
  } catch (e) {
    // Fallback: return a tiny valid empty puzzle if generator fails
    return {
      type: PuzzleTypeIdEnum.HASHI,
      id: `hashi-${Date.now()}`,
      puzzle: [
        [0, 1, 0],
        [0, 0, 0],
        [0, 1, 0],
      ],
      solution: [
        ['0', '1', '-'],
        ['0', '0', '0'],
        ['0', '1', '-'],
      ],
    };
  }
}
